import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { Access, Permission, RoleMenuAccess } from '../models';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuAccessService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Función que obtiene una lista de accesos al menú para el rol
   * @param roleId Indica el id del rol
   * @returns Devuelve una lista de accesos al menú
   */
  getAllRoleMenuAccess(roleId: number) {
    return this._http.get<RoleMenuAccess[]>(`${environment.commonApiUrl}/api/access/role/${roleId}`);
  }

  /**
   * Función que sirve para crear una asignación de acceso al menú para el rol
   * @param roleMenuAccess Objeto de tipo RoleMenuAccess
   * @returns Devuelve un observable de tipo RoleMenuAccess
   */
  createRoleMenuAccess(roleMenuAccess: RoleMenuAccess){
    return this._http.post(`${environment.commonApiUrl}/api/access/role`, roleMenuAccess).pipe(
      map((response: any) => response.access as RoleMenuAccess),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función que sirve para actualizar una asignación de acceso al menú para el rol
   * @param roleMenuAccess Objeto de tipo RoleMenuAccess
   * @returns Devuelve un observable de tipo RoleMenuAccess
   */
   updateRoleMenuAccess(roleMenuAccess: RoleMenuAccess){
    return this._http.put(`${environment.commonApiUrl}/api/access/role`, roleMenuAccess).pipe(
      map((response: any) => response.access as RoleMenuAccess),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función que obtiene una lista de accesos
   * @returns Devuelve una lista de accesos
   */
  getAllAccess() {
    return this._http.get<Access[]>(`${environment.commonApiUrl}/api/access`);
  }

  /**
   * 
   * @param menuTitle Indica el titulo del menú
   * @returns Devuelve si tiene o no acceso a la opción del menú
   */
  haveAccess(url: string) {
    return this._http.get<boolean>(`${environment.commonApiUrl}/api/access/check?url=${url}`);
  }

  /**
   * Obtiene una lista de accesos al menú para el usuario autenticado
   */
  getUserPermissions(){
    return this._http.get<Permission[]>(`${environment.commonApiUrl}/api/menu-items/user`);
  }

}
